import request from '@/utils/request'

//       paramsSerializer: query =>
// qs.stringify(query, {
//     arrayFormat: 'repeat',
//     encode: false
//   })
export function getLockList(query) {
  return request({
    url: '/card-service/v1/smart-lock',
    method: 'get',
    params: query
  })
}
export function getLockListFree(query) {
  return request({
    url: '/card-service/v1/smart-lock/free',
    method: 'get',
    params: query
  })
}

export function deleteLock(data) {
  return request({
    url: '/card-service/v1/smart-lock',
    method: 'delete',
    data
  })
}

// for room screen
export function updateLockForRoom(params) {
  return request({
    url: '/card-service/v1/smart-lock/update-for-room',
    method: 'put',
    params
  })
}
export function updateLockBeforeDeleteRoom(data) {
  return request({
    url: '/card-service/v1/smart-lock/update-for-delete-room',
    method: 'delete',
    data
  })
}

// for lock screen
export function assignLockToRoom(data) {
  return request({
    url: '/card-service/v1/smart-lock/assign-lock-room',
    method: 'post',
    data
  })
}

export function updateRoomForLock(params) {
  return request({
    url: '/card-service/v1/smart-lock/update-for-lock',
    method: 'put',
    params
  })
}
